import { useState } from "react";

import { DBBTyreSearchQueryKeys } from "components/DBB/components/DBBCreateContractModal/components/DBBTyreSearch/queryKeys";
import { useTypedQuery } from "hooks/useTypedQuery";
import { usePermanentTyreBrandOptions } from "modules/AppointmentDetails/components/VehicleTyres/hooks/usePermanentTyreBrandOptions";
import { useCarLocation } from "modules/CarDetails/hooks/useCarLocation";
import { ApiInstance } from "utils/Api";

import type { Car, CarTyres, SEASONS } from "models";

const getTyreOnAnyPosition = (carTyres?: CarTyres) => carTyres?.front_left_tyre ?? carTyres?.front_right_tyre ?? carTyres?.rear_left_tyre ?? carTyres?.rear_right_tyre;

const getExistingCarTyre = (car: Car) => getTyreOnAnyPosition(car.on_car_tyres) ?? getTyreOnAnyPosition(car.in_storage_tyres);

export const useDBBTyreSearch = (car: Car, isOpen: boolean) => {
  const existingTyre = getExistingCarTyre(car);

  const [width, setWidth] = useState(existingTyre?.width ?? null);
  const [height, setHeight] = useState(existingTyre?.height ?? null);
  const [size, setSize] = useState(existingTyre?.size ?? null);
  const [season, setSeason] = useState<SEASONS | null>(null);
  const [manufacturer, setManufacturer] = useState("");

  const carLocation = useCarLocation(car);
  const { data: tyreBrandOptions = [], isFetching: isFetchingBrands } = usePermanentTyreBrandOptions(carLocation);

  const query = useTypedQuery({
    queryKey: DBBTyreSearchQueryKeys.tyreSearchResults,
    queryFn: async ({ baseUrl, endpoint }) =>
      (
        await ApiInstance.post(
          endpoint,
          { width, height, size, season, dealer_location_id: carLocation?.id ?? 0, manufacturer: tyreBrandOptions.find(bo => bo.value === manufacturer)?.text || null },
          baseUrl
        )
      ).data.tyres,
    enabled: isOpen && !!existingTyre?.width
  });

  return {
    width,
    setWidth,
    height,
    setHeight,
    size,
    setSize,
    season,
    setSeason,
    manufacturer,
    setManufacturer,
    tyreBrandOptions,
    isFetchingBrands,
    tyres: query.data ?? [],
    searchTyres: query.refetch,
    isSearching: query.isFetching
  };
};
